<template>
  <div class="sidebar">
    <slot>Sidebar</slot>
  </div>
</template>
<script>

export default {
  name: 'sidebar'
}
</script>



// WEBPACK FOOTER //
// src/components/layoutComponent/Sidebar.vue